import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import AcademicChooseDatasetContainer from "containers/CreateWizard/Academic/AcademicChooseDataset";
import AcademicReviewDatasetContainer from "containers/CreateWizard/Academic/AcademicReviewDataset";

import BusinessChooseDatasetContainer from "containers/CreateWizard/Business/BusinessChooseDataset";
import BusinessChooseSuccessContainer from "containers/CreateWizard/Business/BusinessChooseSuccess";
import BusinessImpactsContainer from "containers/CreateWizard/Business/BusinessImpacts";
import BusinessProcessLimitContainer from "containers/CreateWizard/Business/BusinessProcessLimit";

import ChooseDatasetContainer from "containers/CreateWizard/Dataset/ChooseDataset";
import ChooseSuccessContainer from "containers/CreateWizard/Outcome/ChooseSuccess";
import CostsWaterfallContainer from "containers/CreateWizard/Costs/CostsWaterfall";
import RawCostsContainer from "containers/CreateWizard/Costs/RawCosts";
import CostsSliderContainer from "containers/CreateWizard/Costs/CostsSlider";
import UnderstandActionsContainer from "containers/CreateWizard/Constraints/UnderstandActions";
import ChooseOptionsContainer from "containers/CreateWizard/Target/ChooseOptions";
import ChooseTimePeriodContainer from "containers/CreateWizard/Costs/ChooseTimePeriod";
import ContinuousImpactContainer from "containers/CreateWizard/Costs/ContinuousImpact";
import ContinuousTimeContainer from "containers/CreateWizard/Costs/ContinuousTime";
import ContestContainer from "containers/Contest/Contest";
import ChooseColumnsContainer from "containers/CreateWizard/Dataset/ChooseColumns";
import DescribeColumnsContainer from "containers/CreateWizard/Dataset/DescribeColumns";
import DataCleansingContainer from "containers/CreateWizard/Dataset/DataCleansing";
import CorrelationContainer from "containers/CreateWizard/Dataset/Correlation";
import ContinuousCostsContainer from "containers/CreateWizard/Costs/ContinuousCosts";
import AdvancedCostsContainer from "containers/CreateWizard/Costs/AdvancedCosts";

import ClusterChartContainer from "containers/ClusterChart/ClusterChart";
import InteractionGraphContainer from "containers/Dataset/InteractionGraph";

import DataModeResultsContainer from "containers/Results/DataModeResults";
import ResultsContainer from "containers/Results/Results";
import AcademicResultsContainer from "containers/Results/AcademicResults";
import AcademicEvaluationContainer from "containers/Results/AcademicEvaluation";
import BusinessResultsContainer from "containers/Results/BusinessResults";

import DeployStepContainer from "containers/CreateWizard/Success/DeployStep";

import * as wizardReducer from "containers/Wizard/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as runReducer from "containers/Run/reducer";
import * as projectReducer from "containers/Project/reducer";

import {
  DATASET_OPTIONS,
  ACADEMIC_DATASET_OPTIONS,
  DATA_MODE_DATASET_OPTIONS,
  BUSINESS_CHOOSE_SUCCESS_OPTIONS
} from "containers/Wizard/reducer";

import WizardStep from "components/Wizard/WizardStep";

import { isEnabled } from "utils/featureFlags";

class WizardStepContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  renderType(type) {
    const { aibleMode, options } = this.props;

    const selectedTab = options && options["selectedTab"];
    switch (type) {
      case wizardReducer.STEP_TYPE.ACADEMIC_REVIEW_DATASET.id:
        switch (selectedTab) {
          case ACADEMIC_DATASET_OPTIONS.DATA_UPDATES:
            return <AcademicReviewDatasetContainer {...this.props} key={type} />;
          case ACADEMIC_DATASET_OPTIONS.FIELDS:
            return <ChooseColumnsContainer {...this.props} key={type} />;
          case ACADEMIC_DATASET_OPTIONS.INTERACTIONS:
            return <ClusterChartContainer {...this.props} key={type} />;
          case ACADEMIC_DATASET_OPTIONS.CALCULATED_FIELDS:
            return <ChooseColumnsContainer {...this.props} isCalculated key={type} />;
          case ACADEMIC_DATASET_OPTIONS.DATA_CLEANSING:
            return <DataCleansingContainer {...this.props} key={type} />;
          default:
            return <AcademicReviewDatasetContainer {...this.props} key={type} />;
        }

      case wizardReducer.STEP_TYPE.ACADEMIC_CHOOSE_DATASET.id:
        return <AcademicChooseDatasetContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.DATA_MODE_REVIEW_DATASET.id:
        switch (selectedTab) {
          case DATA_MODE_DATASET_OPTIONS.SELECT_SUCCESS:
            return <AcademicReviewDatasetContainer {...this.props} key={type} isDataMode />;
          case DATA_MODE_DATASET_OPTIONS.FIELDS:
            return <ChooseColumnsContainer {...this.props} key={type} isDataMode />;
          default:
            return <AcademicReviewDatasetContainer {...this.props} key={type} isDataMode />;
        }

      case wizardReducer.STEP_TYPE.DATA_MODE_CHOOSE_DATASET.id:
        return <AcademicChooseDatasetContainer {...this.props} key={type} isDataMode />;

      case wizardReducer.STEP_TYPE.BUSINESS_CHOOSE_DATASET.id:
        return <BusinessChooseDatasetContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.BUSINESS_CHOOSE_SUCCESS.id:
        switch (selectedTab) {
          case BUSINESS_CHOOSE_SUCCESS_OPTIONS.CHOOSE_SUBGROUPS:
            return <BusinessChooseSuccessContainer {...this.props} key={type} />;
          case BUSINESS_CHOOSE_SUCCESS_OPTIONS.FIELDS:
            return <ChooseColumnsContainer {...this.props} key={type} />;
          default:
            return <BusinessChooseSuccessContainer {...this.props} key={type} />;
        }

      case wizardReducer.STEP_TYPE.BUSINESS_IMPACTS.id:
        return <BusinessImpactsContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.BUSINESS_PROCESS_LIMIT.id:
        return <BusinessProcessLimitContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.BUSINESS_SUCCESS.is:
        return <BusinessResultsContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.CHOOSE_DATASET.id:
        switch (selectedTab) {
          case DATASET_OPTIONS.CHOOSE_DATASET:
            return <AcademicReviewDatasetContainer {...this.props} noOutcome key={type} />;
            return <ChooseDatasetContainer {...this.props} key={type} />;
          case DATASET_OPTIONS.FIELDS:
            return <ChooseColumnsContainer {...this.props} key={type} />;
          case DATASET_OPTIONS.DESCRIBE:
            return <DescribeColumnsContainer {...this.props} key={type} />;
          case DATASET_OPTIONS.INTERACTIONS:
            return <ClusterChartContainer {...this.props} key={type} />;
          case DATASET_OPTIONS.CALCULATED_FIELDS:
            return <ChooseColumnsContainer {...this.props} isCalculated key={type} />;
          case DATASET_OPTIONS.DATA_CLEANSING:
            return <DataCleansingContainer {...this.props} key={type} />;
          default:
            return <AcademicReviewDatasetContainer {...this.props} noOutcome key={type} />;
            return <ChooseDatasetContainer {...this.props} key={type} />;
        }

      case wizardReducer.STEP_TYPE.CHOOSE_COLUMNS.id:
        return <ChooseColumnsContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.CORRELATION.id:
        return <CorrelationContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.CLUSTER.id:
        return <ClusterChartContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.INTERACTION.id:
        return <InteractionGraphContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.CHOOSE_SUCCESS.id || wizardReducer.STEP_TYPE.CHOOSE_SUCCESS_DEP.id:
        return <ChooseSuccessContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.COSTS_WATERFALL.id:
        return <CostsWaterfallContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.RAW_COSTS.id:
        return <RawCostsContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.ADVANCED_COSTS.id:
        return <AdvancedCostsContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.COSTS_SLIDER.id:
        return <CostsSliderContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.UNDERSTAND_ACTIONS.id:
        return <UnderstandActionsContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.PROCESS_LIMIT.id:
        return <React.Fragment />;
      // return <ChooseProcessLimitContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.CHOOSE_OPTIONS.id:
        return <ChooseOptionsContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.TIME_PERIOD.id:
        return <ChooseTimePeriodContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.CONTINUOUS_IMPACTS.id:
        return <ContinuousImpactContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.CONTINUOUS_COSTS.id:
        return <ContinuousCostsContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.UNITS.id:
        return <ContinuousTimeContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.CONTEST.id:
        return <ContestContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.DATA_MODE_SUCCESS.id:
        return <DataModeResultsContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.ACADEMIC_SUCCESS.id:
        return <AcademicResultsContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.SUCCESS.id:
        return <ResultsContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.ACADEMIC_EVALUATION.id:
        return <AcademicEvaluationContainer {...this.props} key={type} />;

      case wizardReducer.STEP_TYPE.MODEL_DEPLOYMENT.id:
        return <DeployStepContainer {...this.props} key={type} />;

      default:
        return <div key={type} />;
    }
  }

  render() {
    const { type, stepIndex, id } = this.props;

    return <WizardStep {...this.props}>{this.renderType(type)}</WizardStep>;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  removeStep: () => dispatch(blueprintReducer.removeStepById(ownProps.id, ownProps.blueprintId, ownProps.type)),
  updateOption: (option, value) => dispatch(runReducer.updateWizardOption(ownProps.id, ownProps.type, option, value)),

  incrementStep: (index) => dispatch(wizardReducer.incrementStep(ownProps.id, ownProps.blueprintId, index)),

  increasePriority: (index) => dispatch(blueprintReducer.increasePriority(ownProps.id, ownProps.blueprintId, index)),
  decreasePriority: (index) => dispatch(blueprintReducer.decreasePriority(ownProps.id, ownProps.blueprintId, index)),

  checkIsEnabledTab: (key, value) =>
    dispatch((dispatch, getState) => wizardReducer.checkIsEnabledTab(getState(), key, value)),

  updatePanelMode: (panelMode) =>
    dispatch(runReducer.updatePanelMode(ownProps.originalId, ownProps.blueprintId, panelMode)),
  updateIsEditing: (isEditing) => dispatch(blueprintReducer.updateIsEditing(ownProps.blueprintId, isEditing))
});

const mapStateToProps = (state, ownProps) => {
  const isEditBlueprint =
    (ownProps.id === "new" && ownProps.blueprintId === "new") ||
    blueprintReducer.getIsEditing(state, ownProps.blueprintId);

  const wStep =
    Object.keys(wizardReducer.STEP_TYPE).filter((s) => wizardReducer.STEP_TYPE[s].id === ownProps.type).length > 0
      ? Object.keys(wizardReducer.STEP_TYPE)
          .filter((s) => wizardReducer.STEP_TYPE[s].id === ownProps.type)
          .map((s) => wizardReducer.STEP_TYPE[s])[0]
      : undefined;

  const type = ownProps.type ? ownProps.type : wizardReducer.STEP_TYPE.CHOOSE_DATASET.id;

  const steps = wizardReducer.getSteps(state, ownProps.id, ownProps.blueprintId);

  const stepIndex = wizardReducer.getStepIndex(state, ownProps.id, ownProps.blueprintId);

  let isRunning = false;
  let hasModels = false;
  if (ownProps.id && ownProps.id !== "new") {
    const runStatus = ownProps.id && ownProps.id !== "new" ? runReducer.getStatus(state, ownProps.id) : null;
    isRunning = runStatus !== "DONE" && runStatus !== "ERROR";

    const models = runReducer.getTransformedSortedModels(state, ownProps.id);
    const selModel = runReducer.getSelModel(state, ownProps.id);
    hasModels =
      models !== undefined && selModel !== undefined && models.filter((m) => m.id !== "Current State").length !== 0;
  }

  const aibleMode = wizardReducer.getAibleMode(state, ownProps.id);

  return {
    type: type,

    isEditBlueprint: isEditBlueprint,

    isWizardShow: isEditBlueprint || stepIndex >= ownProps.index,
    isCurrentStep: isEditBlueprint ? false : stepIndex === ownProps.index,
    isFinalStep: steps ? ownProps.index >= steps.length - 1 : false,

    isAdvanced: isEnabled("advanced-wizard"),

    options: runReducer.getWizardOptionsByType(state, ownProps.id, ownProps.type),

    isNextEnabled: wStep === undefined || wStep.isEnabled === undefined ? true : wStep.isEnabled(state, ownProps),

    stepNum: wStep ? wStep.stepNum : undefined,

    name: wStep ? wStep.name || wStep.id : "",

    tabs: wStep ? wStep.tabs : undefined,

    hideTabs: wStep
      ? typeof wStep.hideTabs === "function"
        ? wStep.hideTabs(state, ownProps)
        : wStep.hideTabs
      : undefined,

    hideNext: wStep ? wStep.hideNext : undefined,
    nextName: wizardReducer.getNextName(state, ownProps.id, ownProps.blueprintId),
    showBlueprintCreate: wStep ? wStep.showBlueprintCreate : undefined,
    isCreating: wizardReducer.getIsCreating(state),

    isEmptyModel: runReducer.getIsEmptyModel(state, ownProps.id),

    isShow: true,

    isHover: wizardReducer.getHoverStep(state) === type,

    stepLength: steps ? steps.length : 0,

    isRunning: isRunning,
    hasModels: hasModels,
    notebookProgress: runReducer.getNotebookProgress(state, ownProps.id),
    runCost: runReducer.getRunCost(state, ownProps.id),
    estimatedRunCost: runReducer.getEstimatedRunCost(state, ownProps.id),

    aibleMode: aibleMode,

    projectId: projectReducer.getProjectIdFromRunId(state, ownProps.id),

    errors: runReducer.getErrors(state, ownProps.id),

    panelMode: runReducer.getPanelMode(state, ownProps.originalId)

    // title: isAcademicSuccess ? "Requirement Gathering: Cost Ratio" : undefined
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(WizardStepContainer);
